module.exports = __webpack_public_path__ + "7e64a4bc045d70a9a44bd3be15ffd6d6.png";